export default __webpack_public_path__ + "static/img-slider-04-c3c347d4f3bba59f9f976677c0ad7ac2.png";